import { Record } from "immutable";

const DemandDataItemRecord = Record({
  timestamp: null, // timestamp
  apparentPower: null
});

const createDemandDataItemRecord = dataItem => {
  return DemandDataItemRecord(dataItem);
};

export { createDemandDataItemRecord };

export default DemandDataItemRecord;
